/*
 * Author: Harper Yan
 * File Created: Friday, 24-07-12 10:53 am
 * Last Modified: Monday, 25-07-21 10:54 am, by Dw
 */

import { ComponentType } from 'react';
import { ModalProps } from '@mui/material';
import { useScreenSize } from '../../../../utils';
import { MessageComponentProps } from '../../../@type';
import { showDialog, showDialogAsync } from '../../actions';
import { BaseDialog, BaseDialogProps } from '../../components/BaseDialog';
import { StyledDrawer } from './style';
export interface DrawerDialogProps extends ModalProps, Omit<BaseDialogProps, 'children' | 'classes'> {
  noAutoAdjust?: boolean;
}
export default function DrawerDialog(props: DrawerDialogProps) {
  const {
    noAutoAdjust = false,
    ...resProps
  } = props;
  const isXsScreen = useScreenSize('xs');
  if (isXsScreen && !noAutoAdjust) {
    return <StyledDrawer anchor="bottom" {...resProps} />;
  }
  return <BaseDialog {...resProps} data-sentry-element="BaseDialog" data-sentry-component="DrawerDialog" data-sentry-source-file="index.tsx" />;
}
type IExtraParams = {
  dialogProps?: MessageComponentProps<DrawerDialogProps>;
};
export type EnhancedParams<T extends Record<string, any>> = IExtraParams & T;
export const showDrawerDialog = <T extends Record<string, any> = {},>(Comp: ComponentType<T & IExtraParams>, params?: EnhancedParams<T>) => {
  const {
    dialogProps,
    ...resParams
  } = params || {};
  const EnhancedComponent = (props: DrawerDialogProps) => <DrawerDialog {...{
    showClose: true,
    ...props
  }} data-sentry-element="DrawerDialog" data-sentry-component="EnhancedComponent" data-sentry-source-file="index.tsx">
      <Comp {...resParams as T} dialogProps={props} data-sentry-element="Comp" data-sentry-source-file="index.tsx" />
    </DrawerDialog>;
  return showDialog(EnhancedComponent, dialogProps);
};
export const showDrawerDialogAsync = <T extends Record<string, any> = {},>(Comp: ComponentType<T & IExtraParams>, params?: EnhancedParams<T>) => {
  const {
    dialogProps,
    ...resParams
  } = params || {};
  const EnhancedComponent = (props: DrawerDialogProps) => <DrawerDialog {...{
    showClose: true,
    ...props
  }} data-sentry-element="DrawerDialog" data-sentry-component="EnhancedComponent" data-sentry-source-file="index.tsx">
      <Comp {...resParams as T} dialogProps={props} data-sentry-element="Comp" data-sentry-source-file="index.tsx" />
    </DrawerDialog>;
  return showDialogAsync(EnhancedComponent, dialogProps);
};